import {
  profile_card_item_styles_default
} from "./chunk.HFCNTRWL.js";
import {
  e,
  i,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/profile-card-item/profile-card-item.ts
var FadvProfileCardItem = class extends s {
  constructor() {
    super(...arguments);
    this.name = "";
    this.highlighted = false;
  }
  firstUpdated() {
    var _a, _b;
    (_b = this.profileCardItem) == null ? void 0 : _b.classList.toggle("profile-card-item--last-child", ((_a = this.parentElement) == null ? void 0 : _a.lastElementChild) === this);
  }
  render() {
    const typographyType = this.highlighted ? "label-small" : "label-x-small";
    const typographyWeight = this.highlighted ? "500" : "400";
    return $`<div part="base" class="profile-card-item"><fadv-typography type="${typographyType}" weight="${typographyWeight}" >${this.name}<span class="profile-card-item--value"><slot></slot></span></fadv-typography></div>`;
  }
};
FadvProfileCardItem.styles = profile_card_item_styles_default;
__decorateClass([
  i(".profile-card-item")
], FadvProfileCardItem.prototype, "profileCardItem", 2);
__decorateClass([
  e()
], FadvProfileCardItem.prototype, "name", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvProfileCardItem.prototype, "highlighted", 2);
FadvProfileCardItem = __decorateClass([
  n("fadv-profile-card-item")
], FadvProfileCardItem);

export {
  FadvProfileCardItem
};
